<ng-container *ngIf="!isLoading; else loadingTemplate">
  <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
    <app-external-header
      style="width: 100%; z-index: 1000; position: relative;"
      [isCompanyProfile]="true"
      [isProfile]="false"
      [isMobile]="isMobile"
      [isInboxPresent]="true"
      [showButtons]="false"
      [showProfilePicture]="true"
    ></app-external-header>
  </div>

  <div class="page-content">
    <div class="job-card jobs-wrapper">
      <app-job style="width:100%;  padding: 2rem;" [job]="job"></app-job>
    </div>

    <div class="applications-table">
      <app-applications-table [applications]="applications"></app-applications-table>
    </div>

  </div>

  <div class="footer-class footer-container">
    <app-footer></app-footer>
  </div>
</ng-container>



<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
